import React, { useEffect, useState } from 'react';
import ListTableView from './ListTableView';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import useStyles from '../NewsManagement/index.style';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getContactContainerHeight } from '@jumbo/constants/AppConstants';
import EmptyResult from './EmptyResult';
import NewsItemHeader from './NewsItemHeader';
import { getNewsList, setNewsFilterType } from 'redux/actions/NewsManager';
import { Pagination } from '@material-ui/lab';

const NewsList = ({ width }) => {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);

  const { newsList, newsFilterType, newsListMeta } = useSelector(({ news }) => news);
  
  useEffect(() => {
    dispatch(getNewsList({ ...newsFilterType }));
  }, [dispatch, newsFilterType]);

  useEffect(() => {
    dispatch(setNewsFilterType({ ...newsFilterType, page }))
  }, [page])

  const handlePage = (event, value) => {
    setPage(value);
  };

  const classes = useStyles({
    height: getContactContainerHeight(width),
  });

  return (
    <Box className={classes.inBuildAppCard}>
      <NewsItemHeader />
      {newsList.length > 0 ? (
        <Box className={classes.inBuildAppMainContent}>
          <PerfectScrollbar className={classes.perfectScrollbarContactCon}>
            <ListTableView />
          </PerfectScrollbar>
          <Pagination
            className={classes.paginationRoot}
            count={newsListMeta.total_pages}
            page={page}
            onChange={handlePage}
            color="primary"
          />
        </Box>
      ) : (
        <Box className={classes.inBuildAppMainContent}>
          <EmptyResult />
        </Box>
      )}
    </Box>
  );
};

export default NewsList;

NewsList.prototype = {
  onShowContactDetail: PropTypes.func,
};
